import SearchModal from 'components/SearchModal';
import React from 'react';
import { createEpisodePath, createPodcastPath } from 'utils/routes';

export interface PodcastSearchNavigationModalProps {}

const createAutoplayEpisodePath = (podcastId: string, episodeId: string) =>
  createEpisodePath(episodeId, podcastId, { startSec: 0 });

const PodcastSearchNavigationModal: React.FC<
  PodcastSearchNavigationModalProps
> = () => (
  <SearchModal
    name="PodcastSearchNavigation"
    navigationConfig={{
      createPodcastPagePath: createPodcastPath,
      createEpisodePagePath: createEpisodePath,
      createAutoplayEpisodePagePath: createAutoplayEpisodePath,
    }}
  />
);

export default PodcastSearchNavigationModal;
